import {fetchAndParse} from "./utilts";
import axios from "../utils/axios";

export function fetchButtonSettings(company: string, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/widget_button_settings/${company}/`,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response: any) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createButtonSettings(data: any, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/widget_button_settings/`,
        data,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response: any) => {
        if (response.status === 201) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function updateButtonSettings(id: string, data: any, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .patch(
        `${process.env.REACT_APP_API_DOMAIN}/widget_button_settings/${id}/`,
        data,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response: any) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function retrieveButtonSettingsOptions(token: string) {
  const url = new URL(
    `/widget_button_settings/`,
    process.env.REACT_APP_API_DOMAIN
  );
  return fetchAndParse<any>(url.toString(), {
    method: "OPTIONS",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}